import { IParamsToSend } from '@base/@types/providers/Otb/FollowUpProvider'

export const followUpRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: true
  },

  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  categoria: {
    ids: [],
    agrupar: true
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  produto: {
    ids: [],
    agrupar: false
  }
}
